import React from 'react';
import classNames from 'classnames';

import { urlIsZiggeo } from 'utils/url';
import { Accordion } from 'ui';
import { Text, TEXT_VARIANTS } from 'ui/Typography';
import ZiggeoMediaPlayer from 'ui/ZiggeoVideo/ZiggeoMediaPlayer';
import ZiggeoVideoPlayer from 'components/ui/ZiggeoVideo/ZiggeoVideoPlayer';
import { useAutosizeVideos } from 'components/shared/hooks/index';
import Criteria from './Criteria';

const QuestionPrompt = props => {
  const {
    criteria,
    exampleRecordingHtml = '',
    odpQuestionPrompt,
    apiKey,
    url,
    hasZiggeoForAllMedia,
  } = props;
  const { embedRef, embedContainer } = useAutosizeVideos(
    exampleRecordingHtml,
    0.56,
  );

  const ziggeoToken = urlIsZiggeo(url);

  const renderZiggeoPlayer = () => {
    if (hasZiggeoForAllMedia || !odpQuestionPrompt) {
      return (
        <ZiggeoMediaPlayer
          apiKey={apiKey}
          token={ziggeoToken}
          className="maxh-600"
        />
      );
    }
    return (
      <ZiggeoVideoPlayer
        apiKey={apiKey}
        token={ziggeoToken}
        className="maxh-600"
      />
    );
  };

  return (
    <>
      <Accordion
        title={t('questions.question.tips')}
        fullWidth={odpQuestionPrompt}
        whiteBackground={odpQuestionPrompt}
      >
        <div className="d-f m-fd-rc p-16">
          {exampleRecordingHtml && (
            <div
              className={classNames('d-f fd-c f-1 m-mh-a', {
                'QuestionPrompt-greatExampleContainerTall':
                  criteria.length === 0,
                'QuestionPrompt-greatExampleContainer mr-16':
                  criteria.length > 0,
              })}
              ref={embedContainer}
            >
              <Text className="mb-16" variant={TEXT_VARIANTS.BODY_BOLD}>
                {t('questions.question.media_recording.highlighted_example')}
              </Text>
              {ziggeoToken && renderZiggeoPlayer()}
              {!ziggeoToken && (
                <div
                  ref={embedRef}
                  dangerouslySetInnerHTML={{ __html: exampleRecordingHtml }}
                />
              )}
            </div>
          )}
          {criteria.length > 0 && (
            <div className="f-1 mb-8 d-f fd-c">
              <Text className="mb-16" variant={TEXT_VARIANTS.BODY_BOLD}>
                {t('questions.question.focus_areas')}
              </Text>
              <Criteria criteria={criteria} />
            </div>
          )}
        </div>
      </Accordion>
      <hr className="mb-32 mt-0 border-gray-light" />
    </>
  );
};

export default props => <QuestionPrompt {...props} />;
